export default __webpack_public_path__ + "static/media/2188.76b1dcc6.png";